<template>
  <v-flex xs12 sm10 md6>
    <v-card class="elevation-12">
      <v-card-title class="primary justify-center">
        <v-icon color="white" size="32">mdi-account-key</v-icon>
        <h2 class="headline ml-2 white--text">Login</h2>
      </v-card-title>
      <v-card-text class="pa-10">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            prepend-inner-icon="mdi-email"
            name="email"
            label="Email"
            type="email"
            v-model="email"
            :rules="emailRules"
            hint="Enter your registered email address"
            autofocus
            required
            dense
            outlined
          ></v-text-field>
          <v-text-field
            prepend-inner-icon="mdi-account-key"
            label="Password"
            :type="showpwd ? 'text' : 'password'"
            v-model="password"
            :rules="passwordRules"
            required
            dense
            outlined
            :append-icon="showpwd ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showpwd = !showpwd"
            @keyup.enter.native="login"
          ></v-text-field>
          <div class="text-center">
            <div>
              Do not have an account?&nbsp;
              <router-link to="/register">Register</router-link>
            </div>
            <div>
              <router-link to="/resetpassword">Forgot Password?</router-link>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <div class="text-center pb-10">
        <v-btn color="primary white--text" class="mr-2" to="/">Cancel</v-btn>
        <v-btn color="primary white--text" :disabled="!valid" @click="login"
          >Sign In</v-btn
        >
      </div>
    </v-card>
  </v-flex>
</template>

<script>
import AuthLayout from "@/layouts/AuthLayout.vue";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";
import router from "@/router";

export default {
  name: "login",
  data() {
    return {
      currentlyOnline: 0,
      valid: true,
      password: "",
      showpwd: false,

      passwordRules: [
        (v) => !!v || "Password is required",
        (v) =>
          (v && v.length >= 6) || "Password must be less than 6 characters",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
    };
  },
  created() {
    this.$emit(`update:layout`, AuthLayout);
  },
  methods: {
    async login() {
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
      if (this.$refs.form.validate()) {
        try {
          let response = await firebase
            .auth()
            .signInWithEmailAndPassword(this.email, this.password);
          if (response.user.emailVerified) {
            this.$router.push("/decoder");
          } else {
            this.$router.push("/");
            this.$vToastify.error(
              "Please verify your identity by using the link in the validation email sent.",
              "ERROR!"
            );
          }
        } catch (e) {
          this.$router.push("/");
          this.$vToastify.error(
            "Failed to Sign In. Please provide your valid credentials.",
            "ERROR!"
          );
        }
      }
    },
  },
};
</script>

<style scoped>
.v-btn {
  color: rgb(255, 255, 255) !important;
  background-color: #0b2545 !important;
}
.theme--light.v-btn--disabled {
  color: rgb(255, 255, 255) !important;
  background-color: #b8b8b8 !important;
}
</style>
